import { ArrowRight, Phone } from "lucide-react";
import { SHOP } from "@/lib/api";
import Logo from "@/components/Logo";

const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center pt-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwYXV0byUyMG1lY2hhbmljJTIwZ2FyYWdlJTIwZGFya3xlbnwwfHx8fDE3ODI2ODMxMjd8MA&ixlib=rb-4.1.0&q=85"
          alt="Mid Del Auto garage"
          className="w-full h-full object-cover opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,transparent_0%,#0a0a0a_100%)]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-24 w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-[2px] w-12 bg-[#e10600]" />
            <span className="font-['Exo_2'] uppercase text-xs tracking-[0.4em] text-[#e10600] font-bold">Midwest City • Oklahoma</span>
          </div>
          <h1 className="font-['Anton'] text-6xl sm:text-7xl md:text-8xl lg:text-9xl uppercase leading-[0.9] mb-6">
            <span className="text-chrome">Honest</span><br />
            <span className="text-[#e10600]">Work.</span><br />
            <span className="text-chrome">Done Right.</span>
          </h1>
          <p className="font-['Exo_2'] text-lg md:text-xl text-gray-300 max-w-xl mb-10 leading-relaxed">
            Honest mechanics. Expert hands. {SHOP.name} keeps {SHOP.address.split(",")[1]?.trim() || "Midwest City"} rolling — from oil changes to full engine rebuilds.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#booking" data-testid="hero-book-button"
              className="group inline-flex items-center justify-center gap-3 bg-[#e10600] hover:bg-[#ff1a1a] text-white px-8 py-5 uppercase tracking-widest text-sm font-bold transition-colors">
              Book Appointment
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href={`tel:${SHOP.phoneTel}`} data-testid="hero-call-button"
              className="inline-flex items-center justify-center gap-3 border border-[#2e2e2e] hover:border-white text-white px-8 py-5 uppercase tracking-widest text-sm font-bold transition-colors">
              <Phone className="w-4 h-4" /> {SHOP.phone}
            </a>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-6 max-w-xl">
            {[
              { v: "30+", l: "Years Experience" },
              { v: "8", l: "Core Services" },
              { v: "100%", l: "Honest Work" },
            ].map((s) => (
              <div key={s.l} data-testid={`hero-stat-${s.l.toLowerCase().replace(/\s+/g, "-")}`} className="border-l-2 border-[#e10600] pl-4">
                <div className="font-['Anton'] text-chrome text-4xl">{s.v}</div>
                <div className="font-['Exo_2'] text-[10px] uppercase tracking-[0.25em] text-gray-400 mt-1">{s.l}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 hidden lg:flex items-center justify-center relative">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_#e10600_0%,_transparent_55%)] opacity-25 blur-3xl" />
          <img
            src="https://customer-assets.emergentagent.com/job_mid-del-auto/artifacts/axdyn9hl_C1793D7D-455B-4CCD-9B2F-3C7E85DE9D86.png"
            alt="Mid Del Auto crest"
            className="relative w-full max-w-2xl object-contain drop-shadow-[0_0_60px_rgba(225,6,0,0.45)]"
            data-testid="hero-logo-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
